import Accordians from "../Components/Accordians";
import ChooseSpaceX from "../Components/ChooseSpaceX";
import Footer from "../Components/Footer";
import LogisticsCards from "../Components/LogisticsCards";
import LogisticsContent from "../Components/LogisticsContent";
import LogisticsHome from "../Components/LogisticsHome";
import Navbar from "../Components/Navbar";
import ScrollUp from "../Components/ScrollUp";

const Logistics = () => {
  const accordionItems = [
    {
      id: "1",
      question: "What are logistics and transport services?",
      answer:
        "They cover the planning, execution, and management of moving goods from origin to destination. This includes fleet management, route planning, warehousing, shipment tracking, and last-mile delivery, all supported by modern software solutions.",
    },
    {
      id: "2",
      question: "What is included in a logistics management system?",
      answer:
        "A complete logistics management system typically includes order management, fleet and driver management, route optimization, real-time GPS tracking, warehouse and inventory management, proof of delivery, and analytics dashboards.",
    },
    {
      id: "3",
      question: "What is the cost of building a logistics solution?",
      answer:
        "The cost depends on the scope of the project, such as the number of modules, integrations, and the size of your fleet or operations. Consult with our team and get an estimate of the exact rates depending on your requirements and specifications.",
    },
    {
      id: "4",
      question: "Can you integrate with our existing systems?",
      answer:
        "Yes. We build logistics solutions that integrate with your existing ERPs, e-commerce platforms, third-party carriers, and payment systems, so you can digitize your operations without disrupting your current workflows.",
    },
    {
      id: "5",
      question:
        "Do you provide transport services for universities and educational institutes?",
      answer:
        "Yes. SpaceX offers dedicated fleet and transport services for universities and educational institutes, including daily pick-and-drop routes from various cities, as well as transport for study tours and trips. Our services focus on safety, punctuality, and reliable route coverage for students and staff.",
    },
  ];

  const chooseSpaceXTitle = "Why Choose SpaceX?";
  const chooseSpaceXParagraphs = [
    "SpaceX is a technology partner that has delivered great logistics and transport solutions to its clients. By using advanced techniques and tools, we adhere to the best quality of work.",
    "By continuously improving our skill set, we develop expertise in the latest technologies that power modern supply chains, from GPS tracking and IoT sensors to AI-driven route optimization. From the initial design to the delivery of the final product, our procedure is highly professional and transparent.",
    "Our team builds custom fleet management platforms, shipment tracking systems, warehouse management solutions, and driver applications tailored to the way your business operates. We implement all the latest technologies so that you can strengthen your operations and enhance your customer experience.",
    "To streamline your supply chain according to your needs and requirements, you need highly advanced custom logistics solutions that meet the demands of the modern market.",
    "SpaceX, with its highly experienced development team, can design and develop custom logistics and transport applications that meet your business needs. Our team takes our clients' vision into strong consideration when developing solutions that keep goods moving and customers happy.",
  ];

  return (
    <div className="web3-page">
      <Navbar />
      <LogisticsHome />
      <LogisticsContent />
      <LogisticsCards />
      <Accordians items={accordionItems} />
      <ChooseSpaceX
        title={chooseSpaceXTitle}
        paragraphs={chooseSpaceXParagraphs}
      />
      <Footer />
      <ScrollUp />
    </div>
  );
};

export default Logistics;
